import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { applicationSelectors, userSelectors } from '@app/core/ngrx/selectors';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { MutationService } from '@core/graphql/mutation/mutation.service';
import { NavController, PopoverController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { hasHousing } from '@shared/utils/index';
// ngrx actions
import { State } from '@core/ngrx/reducers';
import { faQuestionCircle, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import {
    faFile,
    faShoppingCart,
    faExclamationCircle,
    faFileEdit,
    faCheckCircle,
    faUpload,
    faSignature,
    faHouse,
    faFileCheck,
    faFileDownload,
} from '@fortawesome/pro-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { WarningService } from '@app/core/services/warning/warning.service';
import { flatMap } from 'rxjs/operators';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { datadogRum } from '@datadog/browser-rum';
import { ApplicationInformationTooltipComponent } from '../application-information-tooltip/application-information-tooltip.component';
import { RequirementItems } from '@app/core/interfaces/RequirementChecklist';
import moment from 'moment';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { UserService } from '@app/core/services/user/user.service';
import { DocumentService } from '@app/core/services/document/document.service';
import { QueryService } from '@app/core/graphql/query/query.service';
import Application from '@app/core/interfaces/Application';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DocumentStatusChipComponent } from '../document-status-chip/document-status-chip.component';
import { SafePipe } from '@app/shared/pipes/safe/safe.pipe';
import { NbspToSpacePipe } from '@app/shared/pipes/nbsp-to-space/nbsp-to-space.pipe';
import { ChecklistPipe } from '@app/shared/pipes/checklist/checklist.pipe';
@Component({
    selector: 'app-general-documents',
    templateUrl: './general-documents.component.html',
    styleUrls: ['./general-documents.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule,
        FontAwesomeModule,
        DocumentStatusChipComponent,
        SafePipe,
        NbspToSpacePipe,
        ChecklistPipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeneralDocumentsComponent implements OnChanges {
    complete: any = {};
    existingPreDepartureOrientation: any = {};
    existingPreEnrollmentOrientation: any = {};

    hasUsCanPassport: boolean = false;

    showPreEnrollmentRegistration: any = {};
    showPreDepartureRegistration: any = {};

    orientationAlertOptions: any = {
        header: 'Select Orientation Date',
        subHeader: 'Select a date and time.',
        okText: 'Register',
    };

    customReqMalpracticeCheck = false;
    //
    @ViewChild('downloadZipLink', { static: false })
    private downloadZipLink: ElementRef;

    /**
     *
     *
     * item 1 = CV ['cv']
     * item 2 = Passport ['passport']
     * item 3 = malpractice insurance ['malpractice'] NOT USED MORE , use gql query applicationMalpracticeDocuments
     * item 4 = school records / letter dean / diploma ['schoolrecords']
     * item 5 = immunizations - Not used anymore, using getMyImmunizationDocs endpoint meow ['immune']
     * item 6 = letter of recommendation ['letterofrecc']
     * item 7 = proof visa ['visaproof']
     * item 8 = health insurance ['healthinsurance']
     * item 9 = records - No Item 9!! []
     * item 10 = toefl ['toefl']
     *
     *
     */

    @Input() status?: any;

    censorContent$ = this.store.pipe(select(userSelectors.blockContent)); // visitor block content if 'unmanaged'

    textcontent: any;
    orientations: any;

    $USER_ID = this.store.select(userSelectors.getUserID);
    $APPLICATION_ID = this.store.select(applicationSelectors.getCurrentApplicationId);
    $CLINICAL_DOCUMENT_LIST = this.store.select(applicationSelectors.getClinicalDocumentList);
    //
    USER_ID: string;
    APPLICATION_ID: string;
    CA_MISSING_FLAG = false;

    icons: any = {
        file: faFile,
        question: faQuestionCircle,
        shoppingCart: faShoppingCart,
        faHouse: faHouse,
        rejectedOrAccepted: faExclamationCircle,
        blocked: faFileEdit,
        completed: faCheckCircle,
        incompleted: faUpload,
        faInfoCircle: faInfoCircle,
        faSignature: faSignature,
        faFileSignature: faFileSignature,
        acknowledged: faFileCheck,
        download: faFileDownload,
    };

    requirementsList: any[];
    checklistStatus: any = null;
    //
    immunizationStatusesList: any[] = [];
    //
    immunizationGeneralStatus: any[] = [];

    constructor(
        public toolService: ToolService,
        private warning: WarningService,
        private modalService: ModalService,
        private navCtrl: NavController,
        private toastService: ToastService,
        private store: Store<State>,
        private applicationService: ApplicationService,
        private mutationService: MutationService,
        private alertController: AlertController,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private popoverCtrl: PopoverController,
        private userService: UserService,
        private documentService: DocumentService,
        private cdr: ChangeDetectorRef,
        private queryService: QueryService
    ) {
        this.listener();
    }

    ngOnChanges() {
        this.complete.isOnlineTelehealth = this.status.application.type.includes('Virtual') ? true : false;

        this.hasUsCanPassport =
            ['United States', 'Canada'].includes(this.status.user.passportissuecountry) && this.status.user.countryofbirth === 'United States';

        this.existingPreEnrollmentOrientation = this.status.application.preenrollmentorientation;
        this.existingPreDepartureOrientation = this.status.application.predepartureorientation;
        //
        this.identifyRegistrationOptions();
        this.getApplicationOrientationSchedule();
        //
        this.complete.cv = this.status.user.item1name === null ? false : this.status.user.item1name.indexOf('Temporary') !== -1 ? false : true;
        this.complete.passport = this.status.user.item2name === null ? false : true;
        // this.complete.malpractice =
        //     this.status.user.item3name === null ? false : true;

        this.complete.schoolrecords = this.status.user.item4name === null ? false : true;
        this.complete.immune = this.status.immunizations.documents.length === 0 ? false : true;
        this.complete.letterofrecc = this.status.user.item6name === null ? false : true;
        this.complete.visaproof = !this.hasUsCanPassport && this.status.user.item7name === null ? false : true;
        this.complete.healthinsurance = this.status.user.item8name === null ? false : true;
        this.complete.toefl = !this.hasUsCanPassport && this.status.user.item10name === null ? false : true;
        this.complete.hashousing = hasHousing(this.status.application);
        this.complete.signedcontract = this.status.application.signedcontract !== null ? true : false;
        this.complete.hasrequestedinvitation = this.status.application.hasrequestedinvitation ? true : false;
        this.complete.passportform = this.hasUsCanPassport
            ? true
            : this.complete.visaproof
            ? true
            : ((this.status.user.passportexpiredate && this.status.user.passportissuedate) || this.status.user.visameetingdate) &&
              this.status.user.passportnumber
            ? true
            : false;

        this.complete.malpractice = this.status.malpracticeApplicationDocuments.length > 0 ? true : false;
        //healthinsuranceApplicationDocuments
        //console.log(this.status);
        this.complete.healthinsurance =
            this.status.user.item8name != null ||
            (this.status.healthinsuranceApplicationDocuments && this.status.healthinsuranceApplicationDocuments.length > 0)
                ? true
                : false;
        if (this.complete.healthinsurance) {
            this.complete.applicationHealthinsuranceDocuments = [...this.status.healthinsuranceApplicationDocuments];
        }

        // used this array for additional document descriptions without processed file names
        // check if requireCustomDocuments exists before mapping
        this.complete.postreservationdocuments = this.status.application.program.requiredpostdocumentlist.requireCustomDocuments
            ? this.status.application.program.requiredpostdocumentlist.requireCustomDocuments
                  .filter((requirement: any) => {
                      return requirement.academicstatus === this.status.user.status || requirement.academicstatus === 'Any' ? true : false;
                  })
                  .filter((requirement: any) => {
                      return requirement.programtype === this.status.application.type || requirement.programtype === 'Any' ? true : false;
                  })
                  .map((requirement: any) => {
                      if (requirement.type === 'Malpractice') {
                          this.customReqMalpracticeCheck = true;
                      }
                      return requirement;
                  })
            : [];

        // Find if user already has malpractice documents
        this.complete.purchasedMalpractice = this.status.applicationDocuments.documents.some((document: any) => {
            if (document.filename.indexOf('Malpractice') !== -1) {
                this.complete.malpracticeLink = document.url;
                return true;
            } else if (document.url.indexOf('malpractice') !== -1) {
                this.complete.malpracticeLink = document.url;
                return true;
            } else {
                return false;
            }
        });

        // end

        // Find if user has received an invitation letter
        // still dont like this but it works
        this.complete.invitationLetterReady = this.status.applicationDocuments.documents.some((document: any) => {
            if (document.filename.indexOf('Invitation_Letter') !== -1) {
                this.complete.letterLink = document.url;
                return true;
            } else {
                return false;
            }
        });
        // end

        this.complete.isOnlineTelehealth =
            this.status.application.type === 'Online Telehealth' ||
            this.status.application.type === 'Online-Telehealth' ||
            this.status.application.type === 'Pre-Med Online Telehealth Shadowing' ||
            this.status.application.type === 'Virtual' ||
            this.status.application.type === 'Virtual Pre-Med Shadowing'
                ? true
                : false;

        this.requirementsList = [...this.status.singleApplicationRequirementList].map((m) => {
            this.status[m['ApplicationRequirements.jsondata'].name];
            return {
                applicationRequirementId: m['ApplicationRequirements.applicationRequirementId'],
                documentId: m.documentid,
                Document: {
                    key: m['ApplicationRequirements.Documents.uri'],
                    filename: m['ApplicationRequirements.Documents.filename'],
                },
                level: m.level,
                levelid: m.programid !== null ? m.programid : m.departmentid !== null ? m.departmentid : m.hostid !== null ? m.hostid : null,
                jsondata: m['ApplicationRequirements.jsondata'],
            };
        });

        this.customReqMalpracticeCheck = this.requirementsList.some((a) => a.jsondata.type === 'malpractice');

        // check if user has submitted documents against application requirements or acknowledged the requirement
        this.requirementsList.map((d) => {
            // document url check
            const requirement = `requirements/${d.applicationRequirementId}/${d.level}/${d.levelid}/`;
            const requirementName = d.jsondata.name; //["ApplicationRequirements.jsondata"].name;
            const AllRequirmentFilePaths = this.status.submittedDocumentsRequirements;
            let foundOldpath = [];
            let foundnewpaths = [];
            if (AllRequirmentFilePaths && Array.isArray(AllRequirmentFilePaths)) {
                foundOldpath = AllRequirmentFilePaths.filter((object) => {
                    if (object.url.includes(requirement)) {
                        const splitUrl = object.url.split(requirement);
                        const requirementFilePath = splitUrl[1];
                        d.urlSubmitted = object.url;
                        d.submitted = true;
                        if (
                            requirementFilePath.includes(`${this.encodeAwsUrl(requirementName).split(' ').join('%20')}?`) ||
                            requirementFilePath.includes(`${this.encodeAwsUrl(requirementName).split(' ').join('%20')}.`) ||
                            requirementFilePath.includes(`${requirementName.split(' ').join('%20')}?`) ||
                            requirementFilePath.includes(`${requirementName.split(' ').join('%20')}.`)
                        ) {
                            //"test%20post%20reservation?" or "test%20post%20reservation." (some files not having file extension)
                            return object;
                        }
                    }
                });

                foundnewpaths = AllRequirmentFilePaths.filter((object) => {
                    //requirements/e0619c46-724a-46cc-a89f-b7890ee2812e/program/100000036/
                    if (object.url.includes(requirement)) {
                        const splitUrl = object.url.split(requirement);
                        const requirementFilePath = splitUrl[1];
                        const requirementNamePath = this.pathRegex(requirementName);

                        if (
                            requirementFilePath.includes(`${requirementNamePath.split(' ').join('%20')}/`) ||
                            requirementFilePath.includes(`${this.encodeAwsUrl(requirementNamePath).split(' ').join('%20')}/`)
                        ) {
                            //"test%20post%20reservation/"
                            return object;
                        }
                    }
                });
            }

            if (foundOldpath.length > 0 || foundnewpaths.length > 0) {
                d.submitted = true;
            }

            // check for acknowledged requirements (no document upload required)
            if (this.status.user.application.submittedrequirements && this.status.user.application.submittedrequirements.length > 0) {
                if (!d.jsondata.usersubmission) {
                    if (this.status.user.application.submittedrequirements.some((req) => req.applicationrequirementid === d.applicationRequirementId)) {
                        const submittedRequirement = this.status.user.application.submittedrequirements.find(
                            (req) => req.applicationrequirementid === d.applicationRequirementId
                        );

                        if (submittedRequirement.submittedValues && submittedRequirement.submittedValues.acknowledged) {
                            d.submitted = true;
                        }
                    }
                }
            }

            return d;
        });

        if (this.status.user.application) {
            if (this.status.user.application.checklist) {
                this.checklistStatus = this.status.user.application.checklist;
            }
        }

        // set immunization status chips
        if (this.status.user.application.immunizationStatuses && this.status.user.application.immunizationStatuses.length > 0) {
            this.immunizationStatusesList = [...this.status.user.application.immunizationStatuses].map((row) => {
                if (row['ImmunizationMaps'] && row['ImmunizationMaps'].length > 0) {
                    return {
                        ...row,
                        immunizationmapid: row['ImmunizationMaps'][0]['id'],
                        status: row['ImmunizationMaps'][0]['status'],
                    };
                } else {
                    return {
                        ...row,
                        status: 'Not Submitted',
                    };
                }
            });

            // check if immunization has been submitted
            // update messaging for immunization chip status
            const immunizationGeneralStatusObj = {
                status: this.immunizationStatusesList.every((val, i, arr) => val.status === 'Complete')
                    ? 'Accepted'
                    : this.immunizationStatusesList.some((val, i, arr) => val.status !== 'Complete')
                    ? 'Pending'
                    : 'Missing',
                type: 'immunization',
            };

            this.immunizationGeneralStatus.push(immunizationGeneralStatusObj);
        }

        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));
    }

    encodeAwsUrl(filename) {
        const encodings = {
            '+': '%2B',
            '!': '%21',
            '"': '%22',
            '#': '%23',
            $: '%24',
            '&': '%26',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '*': '%2A',
            ',': '%2C',
            ':': '%3A',
            ';': '%3B',
            '=': '%3D',
            '?': '%3F',
            '@': '%40',
        };

        return filename.replace(/([+!"#$&'()*+,:;=?@])/gim, (match) => encodings[match]);
    }

    pathRegex(originalFilename: string) {
        const folderNameString = String(originalFilename);
        const noSpacesFolder = folderNameString.replace(/ /g, '_');
        const fileName = noSpacesFolder.replace(/[`~!@#$%^&*()|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
        return fileName;
    }

    listener() {
        //
        this.$USER_ID.subscribe((userid: string) => (this.USER_ID = userid));
        //
        this.$APPLICATION_ID.subscribe((applicationid: string) => (this.APPLICATION_ID = applicationid));
        //
        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));
        //
        this.$CLINICAL_DOCUMENT_LIST.subscribe((clinical_document_list: any) => {
            //
            // console.log('CLINICAL DOCUMENT LIST', clinical_document_list);
            //
            if (clinical_document_list.length > 0) {
                let ca_document = clinical_document_list.find((d: any) => d.filename === 'clinical_agreement.pdf');
                if (!ca_document) {
                    this.CA_MISSING_FLAG = true;
                } else {
                    this.CA_MISSING_FLAG = false;
                }
            } else {
                this.CA_MISSING_FLAG = true;
            }
        });
    }

    async openTooltip(ev: any, type: string, icon: string) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationInformationTooltipComponent,
            event: ev,
            mode: 'md',
            cssClass: 'info-tooltip-popover',
            showBackdrop: false,
            componentProps: {
                type: type,
                icon: icon,
                userEmail: this.status.user.email,
            },
        });
        return popover.present();
    }

    upload = (item: string, url?: string, filename?: string, index?: any) => {
        if (this.status.application.states === 'Accepted' && item !== 'cv' && item !== 'passport') {
            /* empty */
        } else {
            // based on requirements from dynamic pre-acceptance
            // if a document download is required, set usersubmission as true
            let usersubmission = false;
            if (item === 'application') {
                usersubmission = true;
            }

            // create a new object that has program id and application id.
            // program id and application id is needed for receiving aws documents if aws url is not present.
            const completeUserProfile = {
                ...this.status.user,
                programid: this.status.application.programid,
                applicationid: this.status.application.id,
            };

            // datadogRum.addAction(
            //     `application_uploadDocument_${item}_openModal`,
            //     {
            //         applicationid: this.status.application.id,
            //         userid: this.status.application.userid,
            //         item: item
            //     }
            // );

            this.modalService.upload(item, completeUserProfile, this.status.application.id, url, filename, usersubmission).then((response: any) => {
                if (response && response.data && response.data.result && response.data.result == 'error') {
                    /* empty */
                } else if (response.data.result) {
                    // datadogRum.addAction(
                    //     `application_uploadDocument_${item}_success`,
                    //     {
                    //         applicationid: this.status.application.id,
                    //         userid: this.status.application.userid,
                    //         item: item,
                    //         response: response
                    //     }
                    // );
                    // any upload should trigger a valid ping if enrollment is valid via graphql query
                    this.applicationService.enrollmentSubject.next(true);
                    if (index !== null && index !== undefined) {
                        this.complete.postreservationdocuments[index].submitted = true;
                        this.successUpload();
                    } else if (item === 'immune') {
                        //everything handled at document-upload component
                        // this.successUpload();
                    } else if (item === 'malpractice') {
                        this.getHealthInsurnaceAndMalpracticeDocuments(item);
                        this.complete.purchasedMalpractice = true;
                        this.cdr.detectChanges();
                        this.successUpload();
                    } else if (item === 'healthinsurance') {
                        this.getHealthInsurnaceAndMalpracticeDocuments(item);
                        this.complete[response.data.key] = true;
                        this.cdr.detectChanges();
                        this.successUpload();
                    } else {
                        this.complete[response.data.key] = true;
                        this.cdr.detectChanges();
                        this.successUpload();
                    }

                    const checklistItem =
                        this.status.user.application.checklist &&
                        Array.isArray(this.status.user.application.checklist) &&
                        this.status.user.application.checklist.find((checklistItem) => checklistItem.type === item);

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            status: 'Pending',
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                    // else {
                    //     const newChecklistRequirementItem: RequirementItems = {
                    //         requirementid: uuid.v4(),
                    //         ischecked: false,
                    //         iscustom: false,
                    //         label: 'test',
                    //         status: 'Pending',
                    //         type: item,
                    //         uploadedAt: moment(new Date()).utc().format(),
                    //     };
                    // }
                    //els
                } else {
                    // datadogRum.addAction(
                    //     `application_uploadDocument_${item}_failure`,
                    //     {
                    //         applicationid: this.status.application.id,
                    //         userid: this.status.application.userid,
                    //         item: item,
                    //         response: response
                    //     }
                    // );
                }
            });
        }
    };

    additionalFileUpload = (
        item: string,
        applicationRequirementId?: string,
        requirementName?: string,
        index?: number,
        levelType?: string,
        levelId?: string,
        submissionRequired?: boolean
    ) => {
        const completeUserProfile = {
            ...this.status.user,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        let applicationidList = [];
        applicationidList.push(this.status.application.id);

        const type =
            item === 'education'
                ? 'schoolrecords'
                : item === 'resume'
                ? 'cv'
                : item === 'visa'
                ? 'visaproof'
                : item === 'passport'
                ? 'passport'
                : item === 'english'
                ? 'toefl'
                : item === 'immunization'
                ? 'immune'
                : item === 'immune'
                ? 'immune'
                : item === 'healthInsurance'
                ? 'healthinsurance'
                : item === 'malpractice'
                ? 'malpractice'
                : 'application';

        this.modalService
            .upload(type, completeUserProfile, null, null, requirementName, submissionRequired, applicationRequirementId, applicationidList, {
                levelType: levelType,
                levelId: levelId,
            })
            .then((response: any) => {
                if (response && response.data && response.data.result && response.data.result == 'error') {
                    /* empty */
                } else if (response.data.result) {
                    if (index !== null && index !== undefined) {
                        this.requirementsList[index].submitted = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    } else if (item === 'immune') {
                        //always application getting as item from ui click
                        //no chance to reach this block
                        //everything handled at document-upload component for immune if any
                        //this.status.immunizations.documents.push('immunization');
                        this.applicationService.enrollmentSubject.next(true);
                        //this.successUpload();
                    } else {
                        this.complete[response.data.key] = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    }

                    // update status of requirement's checklist item
                    const targetedRequirement = this.requirementsList.find((requirement) => requirement.applicationRequirementId == applicationRequirementId);
                    const checklistItem = this.status.user.application.checklist.find(
                        (item) => item.requirementid === targetedRequirement.applicationRequirementId
                    );

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            status: 'Pending',
                            type: type === 'application' ? 'postreservation' : type,
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                }
            });
    };

    downloadThenUploadModal(
        item?: string,
        key?: string,
        filename?: string,
        index?: number,
        requirementName?: string,
        usersubmission?: boolean,
        applicationRequirement_Id?: string,
        leveltype?: string,
        levelid?: string
    ) {
        const completeUserProfile = {
            ...this.status.user,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        let applicationidList = [];
        applicationidList.push(this.status.application.id);

        const type =
            item === 'education'
                ? 'schoolrecords'
                : item === 'resume'
                ? 'cv'
                : item === 'visa'
                ? 'visaproof'
                : item === 'passport'
                ? 'passport'
                : item === 'english'
                ? 'toefl'
                : item === 'immunization'
                ? 'immune'
                : item === 'immune'
                ? 'immune'
                : item === 'healthInsurance'
                ? 'healthinsurance'
                : item === 'malpractice'
                ? 'malpractice'
                : 'application';

        this.modalService
            .upload(type, completeUserProfile, null, key, requirementName, usersubmission, applicationRequirement_Id, applicationidList, {
                levelType: leveltype,
                levelId: levelid,
            })
            .then((response: any) => {
                if (response && response.data && response.data.result && response.data.result == 'error') {
                    //*
                } else if (response.data.result) {
                    if (index !== null && index !== undefined) {
                        this.requirementsList[index].submitted = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    } else if (item === 'immune') {
                        //this.status.immunizations.documents.push('immunization');
                        this.applicationService.enrollmentSubject.next(true);
                        //this.successUpload();
                    } else {
                        this.complete[response.data.key] = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    }

                    // update status of requirement's checklist item
                    const targetedRequirement = this.requirementsList.find((requirement) => requirement.applicationRequirementId == applicationRequirement_Id);
                    const checklistItem = this.status.user.application.checklist.find(
                        (item) => item.requirementid === targetedRequirement.applicationRequirementId
                    );

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            status: 'Pending',
                            type: type === 'application' ? 'postreservation' : type,
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                }
            });
    }

    clinicalAgreement = () => {
        if (this.status.application.contractapitoken) {
            this.viewClinicalAgreement();
        } else {
            this.signClinicalAgreement();
        }
    };

    /**
     *
     */
    viewClinicalAgreement() {
        //
        // console.log('DOCUMENTS DONE:  ', this.status);
        // console.log(this.CA_MISSING_FLAG);
        //
        if (this.CA_MISSING_FLAG && this.status.application.contractapitoken && this.status.application.signedcontract) {
            //
            const update = {
                applicationid: this.APPLICATION_ID,
                userid: this.USER_ID,
                signatureId: this.status.application.contractapitoken,
            };
            //
            this.applicationService
                .helloSignServerless(update)
                .pipe(
                    flatMap((response: any) => {
                        return this.applicationService.helloSignProccessApplication(update);
                    }),
                    flatMap((response) => {
                        return this.applicationService.getViewClinicalAgreement(this.APPLICATION_ID, this.USER_ID);
                    })
                )
                .subscribe(async (res) => {
                    window.open(res.redirect, '_blank');
                    location.reload();
                });
        } else {
            if (this.status.application.signedcontract) {
                this.applicationService.getViewClinicalAgreement(this.APPLICATION_ID, this.USER_ID).subscribe((res) => {
                    window.open(res.redirect, '_blank');
                });
            } else {
                // console.log('USER HAS TOKEN BUT NEVER COMPLETED SIGNATURE')
                // datadogRum.addAction(
                //     'application_clinicalAgreementDetails_buttonClick_call',
                //     {
                //         applicationid: this.status.application.id,
                //         userid: this.status.application.userid,
                //     }
                // );
                this.signClinicalAgreement();
            }
        }
    }

    downloadInvitationLetter = () => {
        window.open(this.complete.letterLink, '_blank');
    };

    purchaseMalpractice() {
        this.modalService
            .purchaseMalpractice(this.status.application.id)
            .then((res: any) => {
                // malpractice rum action
                // datadogRum.addAction(
                //     'user_malpracticePayment_buttonClick_call',
                //     {
                //         userid: this.status.application.userid,
                //         applicationid: this.status.application.id,
                //         programid: this.status.application.programid,
                //     }
                // );
                if (res.data.purchased) {
                    this.modalService
                        .successfulPayment('malpractice')
                        .then((response: any) => {
                            location.reload();
                            this.applicationService.enrollmentSubject.next(true);
                        })
                        .catch((err: Error) => {
                            // console.log(err);
                            location.reload();
                        });
                }
            })
            .catch((err: Error) => {
                // console.log('stripe modal err: ', err);
            });
    }

    viewMalpracticeDocument = () => {
        if (this.complete.purchasedMalpractice) {
            if (this.complete.applicationMalpracticeDocuments && this.complete.applicationMalpracticeDocuments.length > 0) {
                window.open(this.complete.applicationMalpracticeDocuments[0].url, '_blank');
            } else {
                window.open(this.complete.malpracticeLink, '_blank');
            }
        }
    };

    viewPlacementLetterDocument = () => {
        window.open(this.complete.placementLink, '_blank');
    };

    signClinicalAgreement = () => {
        //
        const navigationExtras: NavigationExtras = {
            queryParams: {
                applicationId: this.APPLICATION_ID,
                userId: this.USER_ID,
            },
        };
        //
        this.navCtrl.navigateForward([`application/${this.APPLICATION_ID}/clinical-agreement`], navigationExtras);
    };

    openPreEnrollmentRegistrationModal() {
        /* empty */
    }

    openHousingModal() {
        if (this.status.application.states === 'Accepted') {
            /* empty */
        } else {
            this.modalService
                .housing(this.status.application.id)
                .then((response: any) => {
                    if (response.data.update) {
                        this.successHousing();
                        this.complete.hashousing = true;
                        this.applicationService.enrollmentSubject.next(true);
                    }
                })
                .catch((err: Error) => {
                    // console.log(err);
                });
        }
    }

    async requestInvitationLetter() {
        let message = 'Must upload a letter from your dean or diploma, proof of passport, and complete the passport details form.';

        const application = await this.queryService.applicationDetails(this.status.application.id).toPromise();

        if (application?.data?.user?.application?.canrequestinvitation) {
            // sent monitor request
            datadogRum.addAction('application_requestInvitationLetter_buttonClick_call', {
                applicationid: this.status.application.id,
                userid: this.status.application.userid,
            });
            this.applicationService.requestInvitation(this.status.application.id).subscribe((response: any) => {
                this.status.hasSubmittedPassportDetails = true;
                this.complete.hasrequestedinvitation = true;
                this.applicationService.enrollmentSubject.next(true);
                this.modalService
                    .successfulAction({
                        message: 'You have successfully requested your invitation letter.',
                    })
                    .then((r: any) => {
                        datadogRum.addAction(`application_uploadDocument_invitationLetter_success`, {
                            applicationid: this.status.application.id,
                            userid: this.status.application.userid,
                        });
                    })
                    .catch((err: Error) => {
                        datadogRum.addAction(`application_uploadDocument_invitationLetter_error`, {
                            applicationid: this.status.application.id,
                            userid: this.status.application.userid,
                        });
                    });
            });
        } else {
            // dean letter
            // CV
            // passport image
            // passportnumber
            // passportissuedate
            // passportexpiredate
            // passportissuecountry
            // visameeting
            if (!this.status.user.item4name) {
                message = 'Must upload letter from your dean or diploma.';
            } else if (!this.status.user.item1name) {
                message = 'Must upload your CV.';
            } else if (this.status.user.item1name.indexOf('InfoCard') !== -1) {
                message = 'You must upload your own Curriculum Vitae or Resume.';
            } else if (!this.status.user.item2name) {
                message = 'Must upload your Passport.';
            } else if (!this.status.user.passportnumber) {
                message = 'Missing passport number. Please complete your passport details form.';
            } else if (!this.status.user.passportissuecountry) {
                message = 'Missing passport country. Please complete your passport details form.';
            } else if (!this.status.user.passportissuedate) {
                message = 'Missing passport issue date. Please complete your passport details form.';
            } else if (!this.status.user.passportexpiredate) {
                message = 'Missing passport expire date Please complete your passport details form.';
            } else if (!this.status.user.visameeting) {
                message = 'Missing passport visa meeting date. Please complete your passport details form.';
            } else {
                message = 'You have not completed your passport details form.';
            }
            this.warning.create(message);
        }
    }

    openHousingSuggestionsModal() {
        this.modalService
            .housingSuggestions(this.status.application.id)
            .then((response: any) => {
                if (response.data.update) {
                    this.successHousing();
                    this.complete.hashousing = true;
                    this.applicationService.enrollmentSubject.next(true);
                }
            })
            .catch((err: Error) => {
                // console.log(err);
            });
    }

    openPassportModal() {
        this.modalService
            .passport(this.status.application.id)
            .then((response: any) => {
                // console.log(response);
                if (response.data.update) {
                    this.toastService.create({
                        message: 'Passport information submitted.',
                        duration: 3000,
                        position: 'top',
                        buttons: [
                            {
                                text: 'Close',
                                role: 'cancel',
                                handler: () => {
                                    console.log('Cancel clicked');
                                },
                            },
                        ],
                        closeButtonText: 'Done',
                        color: 'primary',
                    });
                    this.complete.passportform = true;
                    this.applicationService.enrollmentSubject.next(true);
                    this.requestInvitationLetter();
                }
            })
            .catch((err: Error) => {
                // console.log(err);
            });
    }

    successUpload() {
        this.toastService.create({
            message: 'Document uploaded.',
            duration: 3000,
            position: 'top',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    },
                },
            ],
            closeButtonText: 'Done',
            color: 'primary',
        });
        //
        this.angulartics2GoogleTagManager.eventTrack('Application Details Document Upload', { category: 'Application Document Upload' });
    }

    successHousing() {
        this.toastService.create({
            message: 'Housing information submitted.',
            duration: 3000,
            position: 'top',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    },
                },
            ],
            closeButtonText: 'Done',
            color: 'primary',
        });
    }

    async registrationSuccess(type) {
        const alert = await this.alertController.create({
            header: 'Registration Complete',
            message: 'Thank you for registering for your ' + type + ' orientation.',
            buttons: [
                {
                    text: 'Okay',
                    handler: () => {
                        // console.log('Confirm Okay');
                    },
                },
            ],
        });

        await alert.present();
    }

    preDepartureConferenceSelected(param) {
        this.mutationService
            .preDepartureRegistration({
                predepartureselection: param.detail.value,
                id: this.status.application.id,
            })
            .subscribe((response) => {
                this.existingPreDepartureOrientation = param.detail.value;
            });
        this.registrationSuccess('');
    }

    preDepartureChange() {
        this.existingPreDepartureOrientation = null;
    }

    preEnrollmentConferenceSelected(param) {
        this.mutationService
            .preEnrollmentRegistration({
                preenrollmentselection: param.detail.value,
                id: this.status.application.id,
            })
            .subscribe((response) => {
                this.existingPreEnrollmentOrientation = param.detail.value;
            });
        this.registrationSuccess('Pre-Enrollment');
    }

    preEnrollmentChange() {
        this.existingPreEnrollmentOrientation = null;
    }

    identifyRegistrationOptions() {
        this.mutationService.identifyRegistrationOptions({ id: this.status.application.id }).subscribe((response) => {
            this.showPreDepartureRegistration = response.data.identifyRegistrationOptions.showPreDepartureRegistration;
            this.showPreEnrollmentRegistration = response.data.identifyRegistrationOptions.showPreEnrollmentRegistration;
        });
    }

    getApplicationOrientationSchedule() {
        this.mutationService.getOrientationSchedule({ id: this.status.application.id }).subscribe((response) => {
            if (response.data.getOrientationSchedule.message) {
                this.orientations = null;
                return;
            }
            this.orientations = response.data.getOrientationSchedule;
        });
    }

    viewMultipleDocs(documents, type) {
        //console.log(documents);
        let prefixRoute: string;

        if (type === 'immune') {
            prefixRoute = `userdocuments/${this.status.application.userid}/immunizations/`;
        } else if (type === 'healthinsurance') {
            prefixRoute = `userdocuments/${this.status.application.userid}/applications/${this.status.application.id}/healthinsurance/`;
        }

        const viewKeyDocs = documents.map((item) => ({ ...item, Key: prefixRoute + item.filename }));
        //console.log(viewKeyDocs);
        //console.log(this.status.application.userid);
        this.modalService.documentViewer(viewKeyDocs, this.status.application.userid).then(() => {
            /* empty */
        });
    }

    updateRequirementStatus(requirement: RequirementItems): void {
        if (requirement && requirement.status) {
            this.mutationService.updateRequirementStatus(this.status.application.id, requirement).subscribe((response) => {
                if (response.data.updateRequirementChecklist) {
                    if (response.data.updateRequirementChecklist.checklist) {
                        this.checklistStatus = response.data.updateRequirementChecklist.checklist;
                    }
                }
            });
        }
    }

    viewBasicDocument(doc: any) {
        this.angulartics2GoogleTagManager.eventTrack('Downloaded Personal Document', { category: 'Application Documents' });
        const request = {
            userid: this.status.application.userid,
            type: doc,
        };

        this.userService.getUploadedPersonalDocuments(request).subscribe((res) => {
            if (res.success && res.url) {
                window.open(res.url, '_blank');
            }
        });
    }

    viewAdditionalDocument(requirement, url?: string) {
        if (url && url.includes('https')) {
            window.open(url, '_blank');
            return;
        }

        let request = {
            userid: this.USER_ID,
            applicationRequirementId: requirement.applicationRequirementId,
            type: requirement.jsondata.type,
            level: requirement.level,
            levelId: requirement.levelid,
            name: requirement.jsondata.name,
        };

        this.userService.getUploadedDocuments(request).subscribe((res: any) => {
            if (res.success && res.url) {
                window.open(res.url, '_blank');
            } else {
                this.warning.create('We were unable to process this request. Please contact support for assistance.');
            }
        });
    }

    downloadSample() {
        const link = this.downloadZipLink.nativeElement;
        const hrefLink = this.textcontent.document.components.resources.unpaid.find((item) => item.name.includes("Sample Dean's Letter for a Rotation"));
        if (hrefLink) {
            link.href = hrefLink.url;
            link.target = '_blank';
            link.click();
        }
    }

    downloadImmuneForm() {
        this.documentService.downloadImmunizationForm().subscribe((res: any) => {
            const base64str = res.Body.data;
            const binary = atob(base64str.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            const blob = new Blob([view], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            window.open(url);
            var a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.download = 'AMOpportunities_Certificate_of_Immunization.pdf';
            document.body.appendChild(a);
            a.click();

            // const link = this.downloadZipLink.nativeElement;
            // console.log(link);
            // link.href = url;
            // link.download =
            //     'AMOpportunities_Certificate_of_Immunization.pdf';
            // link.click();
            // window.URL.revokeObjectURL(url);
        });
    }

    openImmunizationModal(event: CustomEvent) {
        if (this.immunizationStatusesList && this.immunizationStatusesList.length > 0) {
            this.modalService.immunizationStatusModal(this.immunizationStatusesList).then((response) => {
                /* empty */
            });
        }
    }

    getHealthInsurnaceAndMalpracticeDocuments(type: string) {
        if (type === 'healthinsurance') {
            this.queryService.applicationHealthinsuranceDocuments(this.status.application.id).subscribe((response: any) => {
                const viewableDocuments =
                    response.data &&
                    response.data.applicationHealthinsuranceDocument &&
                    response.data.applicationHealthinsuranceDocument.documents &&
                    response.data.applicationHealthinsuranceDocument.documents.length > 0
                        ? [...response.data.applicationHealthinsuranceDocument.documents]
                        : [];
                this.complete.applicationHealthinsuranceDocuments = [...viewableDocuments];
            });
        } else if (type === 'malpractice') {
            this.queryService.applicationMalpracticeDocuments(this.status.application.id).subscribe((response: any) => {
                const viewableDocuments =
                    response.data &&
                    response.data.applicationMalpracticeDocument &&
                    response.data.applicationMalpracticeDocument.documents &&
                    response.data.applicationMalpracticeDocument.documents.length > 0
                        ? [...response.data.applicationMalpracticeDocument.documents]
                        : [];
                this.complete.applicationMalpracticeDocuments = [...viewableDocuments];
            });
        } else {
            return;
        }
    }
}
